<template>
  <div class="container">
    <!-- <img class="aigcImgs" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/rabot2.gif" alt=""> -->
    <div class="card">
      <!-- <div class="desc">为您找到以下展览：</div> -->
      <div class="wrapper" :class="customClass">
        <div class="box" @click="goDetail()">
          <div class="leftBox">
            <img class="leftImg" :src="item.logo" alt="">
            <template v-if="length>1">
              <aigcItemNum :mainColor='mainColor' :index="index"></aigcItemNum>
            </template>
          </div>
          <div class="right">
            <div class="name text-ellipsis-1">
              {{ item.name || '暂无' }}
            </div>
            <div class="date">
              {{ item.start_time }}-{{ item.end_time}}
            </div>
            <div class="addr text-ellipsis-overflow-1">
              {{ item.address }}</div>
            <div class="addrBox">
              <arrowRight :mainColor='mainColor'></arrowRight>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import arrowRight from '@/components/arrowRight.vue'
import aigcItemNum from '@/components/aigcItemNum.vue'
export default {
  name: 'aigcExhibitorItem',
  comments: { arrowRight, aigcItemNum },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
    customItemClass: {
      type: String,
      default: '',
    },
    language: {
      type: String,
      default: 'CN',
    },
    customClass: {
      type: [String, Array],
      default: 'mt-10',
    },
    token: {
      type: String,
      default: '',
    },
  },
  components: {},
  computed: {
    phoneNumber() {
      return `tel:${this.item.phone}`
    },
  },
  data() {
    return {
      isWxMini: window.__wxjs_environment === 'miniprogram',
    }
  },
  methods: {
    formatTime(v) {
      return this.$wmtDate.fromatDate(`yyyy-MM-dd`, new Date(v))
    },
    goDetail() {
      // 数贸会定制逻辑
      if (this.item.link) {
        if (this.isWxMini) {
          location.href = this.item.link
        } else {
          window.open(this.item.link)
        }
        return false
      }
      console.log(process.env.VUE_APP_EXH_BASE_URL, process.env)
      if (this.isWxMini) {
        wx.miniProgram.navigateTo({
          url: `/subPackage/meet/holdMeet/detail?code=${this.item.meeting_code}`,
        })
      }
    },
  },
  mounted() {},
}
</script>
<style scoped lang="less">
// @basicWidth: 118px;
// @basicWidth: 68px;
@basicWidth: 80px;
// @cardPadding: 7px;
@cardPadding: 0;
// @cardPadding: 7px;
@wrapperPadding: 5px;
@wrapperBorder: 1px;
@boxLeftImgWidth: 107px;
@boxLeftImgMr: 7px;
@boxLeftImgBorder: 1px;

@boxRightWidth:@cardPadding +  @basicWidth + @wrapperPadding * 2  + @wrapperBorder  +  @boxLeftImgWidth + @boxLeftImgBorder  +  @boxLeftImgMr;
@addrWidth: @boxRightWidth + 19px;
.container {
  display: flex;
  width: 100%;
  // 左边
  .aigcImgs {
    width: 80px !important;
    height: 80px;
    object-fit: cover;
    margin-left: -22px;
    flex-shrink: 0;
  }

  // 右边
  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 9px;
    background-color: #fff;
    padding: @cardPadding;
    box-sizing: border-box;
    .desc {
      font-size: 13px;
      color: #262626;
    }
    .wrapper {
      display: flex;
      box-sizing: border-box;
      background-color: #fff;
      border: @wrapperBorder solid #e0e0e0;
      padding: @wrapperPadding;
      border-radius: 5px;
      margin-top: 5px;
      .box {
        display: flex;
        width: 100%;

        .leftBox {
          position: relative;
          width: @boxLeftImgWidth !important;
          height: 65px;
          margin-right: @boxLeftImgMr;
          flex-shrink: 0;
          border-radius: 4px;
          background-color: #fff;
          .leftImg {
            width: 100%;
            height: 100%;
            display: block;
            background-color: #f5f5f5;
            border: none;
            border-radius: 4px;
            object-fit: contain;
          }
        }
        .right {
          // flex: 1;
          width: calc(100% - 118px);
          padding-top: 2px;
          color: #8c8c8c;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          .name {
            width: 100%;
            font-size: 12px;
            color: #262626;
            font-weight: 700;
          }
          .date {
            width: 100%;
            font-size: 10px;
            color: #9e9e9e;
            padding-top: 2px;
            margin-top: 5px;
          }
          .addr {
            width: 100%;
            margin-right: 4px;
            font-size: 10px;
          }
          .addrBox {
            display: flex;
            width: 100%;
            justify-content: flex-end;
            margin-top: auto;
          }
        }
      }
    }
  }
}

.call-phone,
.im {
  width: 27px;
  height: 27px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: #f5f5f5;
  border-radius: 50%;
  margin-left: 10px;
  font-size: 16px;
}

.baseColor {
  color: #00c4c9;
}
</style>